// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'; // Importamos Routes
import Login from './Vistas/Login'; // Importamos Login
import Lobby from './Vistas/Lobby'; // Importamos Lobby
import MapaSocietario from "./Vistas/MapaSocietario";
import ProtectedRoute from "./Componentes/ProtectedRoute";
import Documentacion from './Vistas/Documentacion';
import PostLoginRedirect from './Componentes/PostLoginRedirect'; // Importamos PostLoginRedirect
import SelectHub from './Vistas/SelectHub';
import CrearHub from './Vistas/CrearHub';
import ImageEditor from './Componentes/DashboardManager/ImageEditor';
import HubConfig from './Componentes/HubConfig';
import CalendarioSemanal from './Vistas/VistasGestion/CalendarioSemanal';
import LobbyGestion from './Vistas/LobbyGestion';
import HistorialCompras from './Vistas/VistasGestion/HistorialCompras';
import DocumentacionConfig from './Vistas/DocumentacionConfig';
import TokenLogin from "./Componentes/TokenLogin";
import VisualizadorDoc from './Vistas/VisualizadorDoc';
import Comunicaciones from './Vistas/Comunicaciones';
import AutoLogout from "./Componentes/AutoLogout";

import { signOut } from "firebase/auth";
import { auth } from "./firebase";

function App() {
  const handleLogout = async () => {
    try {
      await signOut(auth);

      localStorage.clear();
      sessionStorage.clear();

      window.location.href = "/login";
    } catch (error) {
      console.error("Error en logout automático:", error);
    }
  };

  return (
    <Router>
      <AutoLogout 
        timeout={20 * 60 * 1000} 
        onLogout={handleLogout} 
      />
      <div>
        <Routes>
          <Route path="/" element={<Navigate to="/login"/>} />
          <Route path="/login" element={<Login />} />
          <Route path="/post-login" element={<PostLoginRedirect />} />
          <Route path="/select-hub" element={<SelectHub />} />
          <Route path="/create-hub" element={<CrearHub />} />
          <Route path="/token-login" element={<TokenLogin />} />
          <Route
            path="/lobby/:hubId"
            element={
              <ProtectedRoute>
                <Lobby />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lobby/:hubId/config"
            element={
              <ProtectedRoute>
                <HubConfig />
              </ProtectedRoute>
            }
          />
          <Route path="/lobby/:hubId/editor" element={<ProtectedRoute><ImageEditor /></ProtectedRoute>} />
          <Route
            path="/grafo/:hubId"
            element={
              <ProtectedRoute>
                <MapaSocietario />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/documentacion/:hubId" 
            element={
              <ProtectedRoute>
                <Documentacion />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/comunicaciones/:hubId" 
            element={
              <ProtectedRoute>
                <Comunicaciones />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/documentacion/:hubId/permisos" 
            element={
              <ProtectedRoute>
                <DocumentacionConfig />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/documentacion/:hubId/visualizador" 
            element={
              <ProtectedRoute>
                <VisualizadorDoc />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/lobbyGestion/:hubId" 
            element={
              <ProtectedRoute>
                <LobbyGestion />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/lobbyGestion/:hubId/calendario" 
            element={
              <ProtectedRoute>
                <CalendarioSemanal />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/lobbyGestion/:hubId/historialCompras" 
            element={
              <ProtectedRoute>
                <HistorialCompras />
              </ProtectedRoute>
            } 
          />
      </Routes>
      </div>
    </Router>
  );
}

export default App;
